import { FormControl, FormLabel, Button, ButtonGroup, Stack } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { Controller } from "react-hook-form";
import _ from "lodash";

const useStyles = makeStyles(theme => ({
  button: {
    whiteSpace: "unset",
    wordBreak: "break-all",
  },
  label: {
    marginBottom: theme.spacing(1),
  },
}));

const CustomButtonGroup = ({ form, name, label, labelStyles, options, valueTextGetter = _.identity, required, disabled }) => {
  const classes = useStyles();
  
  return (
    <FormControl>
      <Stack {...labelStyles}>
        {label && <FormLabel className={classes.label}>{label}</FormLabel>}
        <Controller
          control={form.control}
          name={name}
          rules={{
            required
          }}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <ButtonGroup variant="outlined" aria-label={`${name} button group`} disabled={disabled || _.isEmpty(options)}>
              {
                _.map(options, (element, index) => (
                  <Button
                  key={index}
                  className={classes.button}
                  onClick={() => onChange(element?.value || element)}
                  variant={value === (element?.value || element) ? "contained" : "outlined"}
                  /* color={value === (element?.value || element) ? "primary" : "default"} */
                  disabled={disabled}
                  >
                    {valueTextGetter(element)}
                  </Button>
                ))
              }
            </ButtonGroup>
          )}
          />
      </Stack>
    </FormControl>
  );
};

export default CustomButtonGroup;